import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-login-header-modal',
  standalone: true,
  imports: [],
  templateUrl: './login-header-modal.component.html',
})
export class LoginHeaderModalComponent {
  public readonly ref = inject(DynamicDialogRef);
}
